import { render } from "./Register.vue?vue&type=template&id=3a0bf196&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=3a0bf196&scoped=true&lang=css"

import exportComponent from "/Users/beerebeerey/github-classroom/MUICCS/cs340prj-beersilver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0bf196"]])

export default __exports__